import { useSearchParams } from "react-router-dom";
import { WHITE_LISTED_FORM_ITEMS_URL_PARAMETER_NAME } from "../../types/form/form.js";
function useWhiteListedFormItems() {
    const [search] = useSearchParams();
    const parameterValue = search.get(WHITE_LISTED_FORM_ITEMS_URL_PARAMETER_NAME);
    const whiteListFormItems = parameterValue ? parameterValue.split(",") : undefined;
    return whiteListFormItems;
}
export { useWhiteListedFormItems };
